import React, { useEffect, useState } from 'react';
import { API_BASE, authHeaders } from '../../utils/api';
import '../../styles/common.css';

const BrochureDownloads = () => {
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchDownloads();
  }, []);

  const fetchDownloads = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/brochure/downloads`, { headers: authHeaders() });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setDownloads(data.data || []);
    } catch (err) {
      setError(err.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this entry?')) return;
    try {
      const res = await fetch(`${API_BASE}/api/brochure/downloads/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSuccess('Entry deleted');
      setDownloads(prev => prev.filter(d => d.id !== id));
    } catch (err) {
      setError(err.message);
    }
  };

  const handleExport = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/brochure/downloads/export/csv`, { headers: authHeaders() });
      if (!res.ok) throw new Error('Export failed');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `brochure_downloads_${Date.now()}.csv`;
      document.body.appendChild(a); a.click(); window.URL.revokeObjectURL(url); document.body.removeChild(a);
      setSuccess('Exported successfully');
    } catch (err) { setError(err.message); }
  };

  const filtered = downloads.filter(d =>
    d.name.toLowerCase().includes(search.toLowerCase()) ||
    d.email.toLowerCase().includes(search.toLowerCase()) ||
    d.mobile.includes(search)
  );

  return (
    <div className="admin-page">
      <div className="page-heading">
        <h1>Brochure Downloads</h1>
        <p>View users who requested the brochure from the Programs Offered page.</p>
      </div>

      {error && <div className="admin-alert error" onClick={() => setError('')}>{error}</div>}
      {success && <div className="admin-alert success" onClick={() => setSuccess('')}>{success}</div>}

      <div className="admin-actions">
        <button onClick={handleExport} className="btn-secondary">📥 Export CSV</button>
      </div>

      <div className="content-section" style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0 }}>Submissions ({filtered.length})</h2>
          <input
            type="text"
            placeholder="Search by name, email or mobile..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', width: '280px', fontSize: '14px' }}
          />
        </div>

        <div className="table-container">
          {loading ? (
            <div className="loading-state">Loading...</div>
          ) : filtered.length === 0 ? (
            <div className="empty-state">No brochure requests found.</div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((d, i) => (
                  <tr key={d.id}>
                    <td>{i + 1}</td>
                    <td>{d.name}</td>
                    <td>{d.email}</td>
                    <td>{d.mobile}</td>
                    <td>{new Date(d.created_at).toLocaleDateString()}</td>
                    <td className="actions">
                      <button className="btn-danger" onClick={() => handleDelete(d.id)}>🗑️ Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrochureDownloads;
